import BuyGiftCard from '@/components/modules/pages/valueCards/BuyGiftCard';
import ValueCards from '@/components/modules/pages/valueCards/ValueCards';

const CheckoutColumn = ({ slugId, placeName, employees, valueCard, showInfo, placeSellsGiftcard, onSelectType }) => (
  <div className="lg:mb-24">
    {placeSellsGiftcard && <BuyGiftCard slug={slugId} onSelectType={onSelectType} />}
    {employees &&
      employees.map((employee) => (
        <ValueCards
          {...{
            id: employee.id,
            header: employee.name,
            valueCards: employee.valueCards,
            showInfo,
            onSelectType,
          }}
          key={employee.id}
        />
      ))}
  </div>
);

export default CheckoutColumn;
